import React from 'react'
import './Home.css'

const ThirdContent = () => {
  return (
    <section className='flex flex-col py-[9rem] px-[1.5rem]' style={{ background: 'linear-gradient(to right, #f6f1d3, #b2b2b2)'}}>
      <div className='ms_tc flex items-center justify-around pb-[40px]' style={{ marginBottom: 'calc(1.5rem - .75rem)' }}>
        <div className='wtc_tc w-[41.6667%] flex justify-end ml-[8.333%]'>
          <div className='w_tc w-[80%]'>
            <span className='text-[1.25rem] rounded-[2px] mb-[5px] text-[#fff] p-3 py-1' style={{
              background: 'linear-gradient(45deg, #0f5ef7, #0f5ef7)', boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.1)' }}>Why Us?</span>
            <h2 className='text-[2rem] font-medium py-[10px]' style={{ fontFamily: 'Nexa Bold, sans-serif' }}>Why eSkooly is the best school management software?</h2>
            <p className=''>Besides, eSkooly is a completely free online school management software, it has more school management features than any other online school management system in the market. It does not end here, eSkooly is still enhancing features. You will be automatically updated as a new feature will be a part of our free school management software. Some main school management features are given below.</p>
          </div>
        </div>
        <div className='w_tc w-[33.33%]'>
          <img src='https://eskooly.com/assets/images/illustrations/mockups/landing3/desktop-min.png' className='h-[300px] w-auto' alt='' />
        </div>
      </div>
    </section>
  )
}

export default ThirdContent